module.exports = __webpack_public_path__ + "img/03.aaae8990.png";